export const BORN_ALIVE = { id: 'born_alive', label: 'Nato vivo' };
export const STILLBORN = { id: 'stillborn', label: 'Nato morto' };
export const BORN_ALIVE_RESIGNED = {
  id: 'born_alive_resigned',
  label: 'Nato vivo dimesso da un reparto diverso da nido',
};
export const DECEASED = {
  id: 'deceased',
  label: 'Nato vivo deceduto entro la prima settimana di vita',
};
